import { CSSObject, Theme } from "@mui/material";
import {
  ConfigurationData,
  ConfigurationVariableValue,
  Field,
  FieldTypes,
  UserAssignment,
  VariableTypes,
} from "../types";

export const compareValue = (
  value: string | number,
  operation: string,
  matchValue: string | number
) => {
  switch (operation) {
    case "===":
      return value === matchValue;
    case ">":
      return value > matchValue;
    case "<":
      return value < matchValue;
    case ">=":
      return value >= matchValue;
    case "<=":
      return value <= matchValue;

    default:
      break;
  }
};

export const formatValue = (type: FieldTypes, value: any) => {
  switch (type) {
    case "number": {
      const numValue = Number(value);
      return isNaN(numValue) ? undefined : numValue;
    }
    case "date": {
      const date = new Date(value);
      if (isNaN(date.getTime())) {
        return undefined;
      }

      return value ? date.toISOString() : undefined;
    }
    case "toggle":
      return value === true;
    default:
      return value;
  }
};

export const getXSForFieldType = (
  field: Field,
  fields: Field[]
): boolean | "auto" | 12 | 6 | 4 | 3 | 2 | 1 => {
  switch (field.type) {
    case "text":
    case "number": {
      const fieldIndex = fields.findIndex((f) => f.id === field.id);
      const isFieldTextAndHasNeighbor =
        fields[fieldIndex - 1]?.type === "text" ||
        fields[fieldIndex - 1]?.type === "number" ||
        fields[fieldIndex + 1]?.type === "text" ||
        fields[fieldIndex + 1]?.type === "number";

      return isFieldTextAndHasNeighbor ? 6 : 12;
    }
    case "select":
      return 12;
    case "radio":
      return 12;
    default:
      return 12;
  }
};

export const returnAssigned = (value: ConfigurationVariableValue) =>
  value.assigned;

export const getDefaultByType = (
  type: VariableTypes
): string | number | Array<any> | undefined => {
  switch (type) {
    case "input_string":
    case "singleSelection_string":
      return "";
    case "singleSelection_date":
    case "input_date":
      return new Date().toISOString();
    case "multiSelection_string":
      return [];
    default:
      return undefined;
  }
};


export const handleLinkToDetails = (id: string) => {
  window.open(`https://new.abb.com/products/${id}`, "_blank");
};
export const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

export const formatUserAssignments = (
  userAssignments: UserAssignment[],
  data: ConfigurationData
) => {
  return userAssignments.reduce((acc: Record<string, any>, assignment) => {
    const assignmentType = data.form.sections
      .find((fields) =>
        fields.variables.find((field) => field.id === assignment.variableId)
      )
      ?.variables.find((field) => field.id === assignment.variableId)?.type;

    if (assignmentType && assignmentType === "multiSelection_string") {
      if (
        acc[assignment.variableId] &&
        Array.isArray(acc[assignment.variableId])
      ) {
        acc[assignment.variableId].push(assignment.variableValue.value);
      } else {
        acc[assignment.variableId] = [assignment.variableValue.value];
      }
    } else {
      acc[assignment.variableId] = assignment.variableValue.value;
    }
    return acc;
  }, {});
};

export const getResponsivePaddings = (
  theme: Theme,
  isPage?: boolean,
): CSSObject => ({
  [theme.breakpoints.down("md")]: {
    padding: `${isPage ? "16px" : "0"} 24px`,
  },

  [theme.breakpoints.down("sm")]: {
    padding: `${isPage ? "12px" : "0"} 12px`,
  },
});

export const sanitizeUserText = (value: string) =>
  value
    .trim()
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");
